import { env } from '../env';

const {
    REACT_APP_SERVER_ORIGIN: SERVER_ORIGIN,
    REACT_APP_ENVIRONMENT: ENVIRONMENT,
    REACT_APP_NEW_PAYMENT_API_ORIGIN: NEW_PAYMENT_API_ORIGIN,
    REACT_APP_NEW_PAYMENT_UI_ORIGIN: NEW_PAYMENT_UI_ORIGIN,
} = env;

export {
    SERVER_ORIGIN,
    ENVIRONMENT,
    NEW_PAYMENT_API_ORIGIN,
    NEW_PAYMENT_UI_ORIGIN,
};
